module.exports = __webpack_public_path__ + "img/shili.1dc70b3d.png";